import type { Course } from '@gpa-scales/shared-types';
import { GradeLevel, Term, AGSubject } from '@gpa-scales/shared-types';

const GRADE_LEVEL_MAP: Record<number, string> = {
  [GradeLevel.Freshman]: '9',
  [GradeLevel.Sophomore]: '10',
  [GradeLevel.Junior]: '11',
  [GradeLevel.Senior]: '12',
};

const TERM_MAP: Record<string, string> = {
  [Term.Fall]: 'Fall',
  [Term.Spring]: 'Spring',
  [Term.Summer]: 'Summer',
  [Term.Q1]: 'Q1',
  [Term.Q2]: 'Q2',
  [Term.Q3]: 'Q3',
  [Term.Q4]: 'Q4',
};

function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * Generate SRAR/SSAR formatted CSV output.
 * SRAR format: Course Name, Grade Level, Course Type, Grade, Credits
 */
export function generateSRAR(courses: Course[]): string {
  const BOM = '\uFEFF';
  const rows: string[][] = [];

  // SRAR header
  rows.push(['Course Title', 'Grade Level', 'Subject', 'Course Type', 'Grade', 'Credits', 'Academic Year', 'Term']);

  for (const course of courses) {
    rows.push([
      escapeCSV(course.name),
      GRADE_LEVEL_MAP[course.gradeLevel] ?? String(course.gradeLevel),
      course.agSubject === AGSubject.None ? 'Other' : course.agSubject,
      course.courseType.toUpperCase(),
      escapeCSV(course.grade),
      course.credits.toFixed(1),
      escapeCSV(course.academicYear),
      TERM_MAP[course.term] ?? course.term,
    ]);
  }

  const csv = rows.map((row) => row.join(',')).join('\n');
  return BOM + csv;
}
